export default __webpack_public_path__ + "static/media/maison.d91e0dae.png";